import { MatMenuTrigger } from '@angular/material/menu';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ItemDto } from '../../core/services/api.service';
import { TexteService } from 'src/app/core/services/texte.service';
import { Router } from '@angular/router';
import { LayoutService } from './../../core/services/layout.service';
import { HeaderMenuListTop, HeaderMenuListBottom } from './menu';

interface HeaderMenuItem {
  label: string;
  class?: string;
  icon?: string;
  children?: HeaderMenuItem[];
}

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LayoutComponent implements OnInit, AfterViewInit {

  public displayLangue = false;
  public langueSelected: ItemDto;
  public langue: string;

  headerMenuWidth: number;
  headerWidth: number;
  headerMenuTop: number;
  headerMenuLeft: number;
  HeaderMenuListTop: HeaderMenuItem[];
  HeaderMenuListBottom: HeaderMenuItem[];
  enteredButton = false;
  isMatMenuOpen = false;
  isMatMenu2Open = false;
  prevButtonTrigger: MatMenuTrigger;

  constructor(
    public texteService: TexteService,
    private router: Router,
    private layoutService: LayoutService
  ) { 
    this.HeaderMenuListTop = HeaderMenuListTop;
    this.HeaderMenuListBottom = HeaderMenuListBottom;
  }
  @ViewChild(MatMenuTrigger) clickHoverMenuTrigger: MatMenuTrigger;

  @ViewChild("top")
  private topDivSelected: ElementRef;
  @ViewChild("contentHeader")
  private contentHeader: ElementRef;
  @ViewChild("header")
  private header: ElementRef;
 
 
  public ngAfterViewInit(): void {
    this.headerMenuWidth = this.topDivSelected.nativeElement.offsetWidth;
    this.headerWidth = this.header.nativeElement.offsetWidth;
    
 }
  ngOnInit(): void {
    this.langue = '';
    this.langueSelected = null;
    this.layoutService.displayLangue.subscribe(display => {
      this.displayLangue = display;
    });

    this.texteService.Langue.subscribe(data => {
      this.langueSelected = data;
      if (this.langueSelected != null) {
        if (data.code === 'fr') {
          this.langue = 'EN';
        } else {
          this.langue = 'FR';
        }
      }
    });    
  }

  public changeLangue() {
    if (this.langueSelected.code === 'fr') {
      this.router.navigate(['en']);
    } else {
      this.router.navigate(['fr']);
    }
  }

  openTab(url: string) {
    window.open(url);
  }

  goToMentions() {
    this.router.navigate(['mentions-legales']);
  }

  goToProtection() {
    this.router.navigate(['protection-donnees']);
  }
  menuEnter() {
    this.isMatMenuOpen = true;
    if (this.isMatMenu2Open) {
      this.isMatMenu2Open = false;      
    }    
  }

  menuLeave(trigger: MatMenuTrigger) {
    setTimeout(() => {
      if (!this.isMatMenu2Open && !this.enteredButton) {
        this.isMatMenuOpen = false;
        trigger.closeMenu();
      } else {
        this.isMatMenuOpen = false;
      }
    }, 1200)
  }

  menu2enter() {
    this.isMatMenu2Open = true;
  }

  menu2Leave(trigger1: MatMenuTrigger, trigger2: MatMenuTrigger) {
    setTimeout(() => {
      if (this.isMatMenu2Open) {
        trigger1.closeMenu();
        this.isMatMenuOpen = false;
        this.isMatMenu2Open = false;
        this.enteredButton = false;
      } else {
        this.isMatMenu2Open = false;
        trigger2.closeMenu();
      }
    }, 600)
  }

  buttonEnter(trigger: MatMenuTrigger, menu: 'menu1' | 'menu2') {
    setTimeout(() => {
      if(this.prevButtonTrigger && this.prevButtonTrigger != trigger){
        this.prevButtonTrigger.closeMenu();
        this.prevButtonTrigger = trigger;
        this.isMatMenuOpen = false;
        this.isMatMenu2Open = false;
        trigger.openMenu();
      }
      else if (!this.isMatMenuOpen) {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger        
        trigger.openMenu();
        
      }
      else {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger
      }
      this.SetWidthDropdownMenu1(trigger, menu);
    },600)
  }

  buttonLeave(trigger: MatMenuTrigger) {
    setTimeout(() => {
      if (this.enteredButton && !this.isMatMenuOpen) {
        trigger.closeMenu();
        
      } if (!this.isMatMenuOpen) {
        trigger.closeMenu();
      } else {
        this.enteredButton = false;
      }
    }, 300)
  }

  buttonEnterLI(levelTwoTrigger: MatMenuTrigger, levelOneTrigger: MatMenuTrigger) {
    setTimeout(() => {
    this.SetWidthDropdownMenu1Lvl2(levelTwoTrigger,levelOneTrigger);
  }, 0)
  }
  // Définir le style Menu1->lvl1: Width, Top, Left, ajouter class
  SetWidthDropdownMenu1(levelOneTrigger: MatMenuTrigger, menu: 'menu1' | 'menu2') {
    if(menu=="menu1"){
      document.getElementById(levelOneTrigger.menu.panelId).style.width =(this.headerMenuWidth + "px");
      document.getElementById(levelOneTrigger.menu.panelId).style.left = ((this.contentHeader.nativeElement.offsetLeft+this.header.nativeElement.offsetLeft))+"px";
    }
    else if (menu=="menu2"){
      document.getElementById(levelOneTrigger.menu.panelId).style.width =(this.headerWidth + "px");
      document.getElementById(levelOneTrigger.menu.panelId).style.left = ((this.header.nativeElement.offsetLeft))+"px";
    }

    document.getElementById(levelOneTrigger.menu.panelId).parentElement.parentElement.classList.add("alignDiv-0");
    document.getElementById(levelOneTrigger.menu.panelId).parentElement.classList.add("alignDiv-0");
  }

  // Définir le style Menu1->lvl2: Width, Top, Left
  SetWidthDropdownMenu1Lvl2(levelTwoTrigger: MatMenuTrigger, levelOneTrigger: MatMenuTrigger) {

    const positionBoundingBox = document.getElementById(levelOneTrigger.menu.panelId).parentElement.parentElement;
    this.headerMenuTop=positionBoundingBox.offsetTop;
    this.headerMenuLeft=positionBoundingBox.offsetLeft;
    if(this.headerMenuLeft==0){
      this.headerMenuLeft = document.getElementById(levelOneTrigger.menu.panelId).offsetLeft;
    }

    console.log("width:"+(this.headerMenuLeft));

    document.getElementById(levelTwoTrigger.menu.panelId).parentElement.style.top ="0px";
    document.getElementById(levelTwoTrigger.menu.panelId).style.width =((this.headerMenuWidth-260) +"px");    
    document.getElementById(levelTwoTrigger.menu.panelId).parentElement.parentElement.style.top =(this.headerMenuTop +"px");
    document.getElementById(levelTwoTrigger.menu.panelId).parentElement.parentElement.style.left = ((this.headerMenuLeft+260))+"px";
  }
}
